export const env = {
  production: false,
  server: 'https://pos-mongo-staging.apps.travelresorts.com',
  mssKey: '_123Q&$38JSH)282HIGII#(12&ZQK$%KSHSC44138^&8',
  tokenexAPIURL: 'https://salesform-api-dev.apps.travelresorts.com',
  sprrURL: 'https://sprr.travelresorts.info',
  tsw: 'https://tsw-api-dev.travelresorts.info',
  tswkey: 'duRalTqJEWohWMHEueeUQdmaNlDmmjR3Plz1cAISkMjmMfgLl0',
  mongoURL: 'https://pos-mongo-staging.apps.travelresorts.com',
  elkapyUrl: 'https://elkapy-dev.apps.travelresorts.com',
  tokenexAPI: 'https://salesform-api-dev.apps.travelresorts.com',
  photoUploadUrl: 'https://hubspot-helper-microservices.apps.travelresorts.com',
  ContractUrl: 'https://pos-pdf-populate-staging.apps.travelresorts.com',
  sharepointService: 'https://sharepoint-api-dev.travelresorts.info',
  eOriginalAPI: 'https://pos-mongo-staging.apps.travelresorts.com/mock',
  eOAPIKEY: "jhcqs[788Ypcb4^SLJH5z8Bv4!rBtbC93&3t",
  salesAppAuthKey: '213918asdasidas08120ijdasdasidj_2193819asd'
};
